<template>
  <modal-box class="account-wallet-modal" :title="'Your wallet'" :size="'medium'">
    <template #body>
      <p class="id">{{ $store.state.userAccount.id }}</p>

      <ul class="links">
        <li class="links__item"><text-link href="#" target="_blank">View on BscScan</text-link></li>
        <li class="links__item"><text-link href="#" target="_blank">Copy Address</text-link></li>
      </ul>
    </template>

    <template #footer>
      <input-button :size="'large'" :type="'common'" @click="onLogout">Logout</input-button>
    </template>
  </modal-box>
</template>

<script>
  import TextLink from '@/components/atoms/TextLink'
  import InputButton from '@/components/atoms/InputButton'
  import ModalBox from '@/components/molecules/ModalBox'

  export default {
    name: 'AccountWalletModal',
    components: {
      InputButton,
      TextLink,
      ModalBox
    },
    methods: {
      onLogout() {
        this.$store.dispatch('onLogout')
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';
  .account-wallet-modal {
    padding-left: 28px;
    padding-right: 28px;
  }

  .id {
    font-weight: 600;
    margin-bottom: 40px;
    word-break: break-all;

    @include media(pc) {
      font-size: 1.8rem;
    }
    @include media(sp) {
      font-size: 1.8rem;
    }
  }
  .links {

    @include media(pc) {
      display: flex;
      font-size: 1.2rem;

      &__item:not(:last-child) {
        margin-right: 64px;
      }
    }
    @include media(sp) {
      font-size: 1.2rem;

      &__item:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }
</style>